export default __webpack_public_path__ + "static/adguard-windows-788a34189c20c3b07e7d0541bf39e9c5.png";